/* Motoking theme — vanilla JS, no dependencies. */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var routes = (window.theme && window.theme.routes) || {};

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '₹{{amount}}';
    var value = (cents / 100);
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      var noDecimals = key.indexOf('no_decimals') > -1;
      var str = noDecimals ? Math.round(value).toString() : value.toFixed(2);
      var parts = str.split('.');
      var sep = key.indexOf('comma_separator') > -1 ? '.' : ',';
      var dec = key.indexOf('comma_separator') > -1 ? ',' : '.';
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return parts.join(dec);
    });
  }

  /* ---------- Drawers ---------- */
  function openDrawer(el) {
    el.hidden = false;
    document.body.classList.add('is-locked');
    var focusable = $('button, a', el);
    if (focusable) focusable.focus();
  }
  function closeDrawer(el) {
    el.hidden = true;
    document.body.classList.remove('is-locked');
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { openDrawer(document.getElementById(opener.getAttribute('data-drawer-open'))); return; }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { closeDrawer(closer.closest('[data-drawer]')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('[data-drawer]').forEach(function (d) { if (!d.hidden) closeDrawer(d); });
    $$('.facets.is-open').forEach(function (f) { f.classList.remove('is-open'); document.body.classList.remove('is-locked'); });
    $$('.nav-item.is-open').forEach(function (n) { n.classList.remove('is-open'); });
  });

  /* ---------- Announcement bar: rotate messages ---------- */
  $$('.topbar:not(.topbar--marquee) .topbar__messages').forEach(function (box) {
    var msgs = $$('.topbar__msg', box);
    if (msgs.length < 2) return;
    var i = 0;
    box.classList.add('is-rotating'); msgs[0].classList.add('is-active');
    setInterval(function () { msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active'); }, 4000);
  });

  /* ---------- Header: search toggle, touch menus ---------- */
  var searchToggle = $('[data-search-toggle]');
  if (searchToggle) {
    searchToggle.addEventListener('click', function () {
      var form = $('[data-search-form]');
      form.classList.toggle('is-open');
      if (form.classList.contains('is-open')) $('input[type=search]', form).focus();
    });
  }
  $$('.nav-item.has-drop > .nav-link').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var item = link.parentElement;
      var touch = window.matchMedia('(hover: none)').matches;
      if (touch && !item.classList.contains('is-open')) {
        e.preventDefault();
        $$('.nav-item.is-open').forEach(function (n) { n.classList.remove('is-open'); });
        item.classList.add('is-open');
        link.setAttribute('aria-expanded', 'true');
      }
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.nav-item')) $$('.nav-item.is-open').forEach(function (n) { n.classList.remove('is-open'); });
  });

  /* ---------- Search form + predictive search ---------- */
  $$('[data-search-form]').forEach(function (form) {
    var type = $('[data-search-type]', form);
    var input = $('[data-predictive-input]', form);
    var box = $('[data-predictive-results]', form);
    form.addEventListener('submit', function () { if (type && !type.value) type.disabled = true; });
    if (!input || !box || !routes.predictiveSearch) return;
    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { box.hidden = true; return; }
      timer = setTimeout(function () {
        var url = routes.predictiveSearch + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url).then(function (r) { return r.json(); }).then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) { box.innerHTML = '<p class="predictive__all">No products found</p>'; box.hidden = false; return; }
          box.innerHTML = products.map(function (p) {
            var img = p.image ? '<img src="' + p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=96" alt="" loading="lazy" width="48" height="48">' : '';
            return '<a class="predictive__item" href="' + p.url + '">' + img + '<span>' + p.title + '<small>' + (p.vendor || '') + ' · ' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</small></span></a>';
          }).join('') + '<a class="predictive__all" href="' + routes.search + '?q=' + encodeURIComponent(q) + '&type=product">View all results →</a>';
          box.hidden = false;
        }).catch(function () { box.hidden = true; });
      }, 220);
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) box.hidden = true; });
  });

  /* ---------- Bike finder ---------- */
  var GARAGE_KEY = 'motoking:bike';
  function initFinder(form) {
    var dataEl = $('[data-finder-data]', form);
    var rows = [];
    try { rows = JSON.parse(dataEl.textContent); } catch (err) { rows = []; }
    var seen = {};
    rows = rows.filter(function (r) {
      var key = (r[0] + '|' + r[1] + '|' + r[2]).toLowerCase();
      if (!r[0] || seen[key]) return false;
      seen[key] = true; return true;
    });
    var selects = $$('select[data-finder-level]', form);
    var button = $('.finder__btn', form);

    function uniq(list) { return list.filter(function (v, i) { return v && list.indexOf(v) === i; }).sort(); }
    function fill(select, values, placeholder) {
      select.innerHTML = '<option value="">' + placeholder + '</option>' + values.map(function (v) { return '<option>' + v.replace(/</g, '&lt;') + '</option>'; }).join('');
      select.disabled = values.length === 0;
    }
    var labels = ['Select Make', 'Select Series', 'Select Model'];
    fill(selects[0], uniq(rows.map(function (r) { return r[0]; })), labels[0]);

    function update(level) {
      var make = selects[0].value, series = selects[1].value;
      if (level === 0) {
        fill(selects[1], make ? uniq(rows.filter(function (r) { return r[0] === make; }).map(function (r) { return r[1]; })) : [], labels[1]);
        fill(selects[2], [], labels[2]);
      }
      if (level <= 1) {
        fill(selects[2], series ? uniq(rows.filter(function (r) { return r[0] === make && r[1] === series; }).map(function (r) { return r[2]; })) : [], labels[2]);
      }
      button.disabled = !make;
    }
    selects.forEach(function (s, i) { s.addEventListener('change', function () { update(i); }); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var make = selects[0].value, series = selects[1].value, model = selects[2].value;
      if (!make) return;
      var match = rows.filter(function (r) { return r[0] === make && r[1] === series && r[2] === model; })[0];
      try { localStorage.setItem(GARAGE_KEY, JSON.stringify([make, series, model])); } catch (err) {}
      if (match && (model || !rows.some(function (r) { return r[0] === make && r[1] === series && r[2]; }))) {
        window.location.href = match[3];
      } else {
        var q = [make, series, model].filter(Boolean).join(' ');
        window.location.href = routes.search + '?type=product&options[prefix]=last&q=' + encodeURIComponent(q);
      }
    });

    // Restore the last bike the customer picked
    try {
      var saved = JSON.parse(localStorage.getItem(GARAGE_KEY) || 'null');
      if (saved && saved[0]) {
        selects[0].value = saved[0]; update(0);
        if (saved[1]) { selects[1].value = saved[1]; update(1); }
        if (saved[2]) selects[2].value = saved[2];
        if (!selects[0].value) update(0);
        button.disabled = !selects[0].value;
      }
    } catch (err) {}
  }
  $$('[data-finder]').forEach(initFinder);

  /* ---------- Hero slider ---------- */
  function initSlider(slider) {
    var slides = $$('.hero__slide', slider);
    var dots = $$('[data-slide-to]', slider);
    if (slides.length < 2) return;
    var index = 0, timer;
    var speed = parseInt(slider.getAttribute('data-autoplay'), 10) * 1000;
    function go(i) {
      slides[index].classList.remove('is-active'); if (dots[index]) dots[index].classList.remove('is-active');
      index = (i + slides.length) % slides.length;
      slides[index].classList.add('is-active'); if (dots[index]) dots[index].classList.add('is-active');
    }
    function play() { if (speed > 0) { clearInterval(timer); timer = setInterval(function () { go(index + 1); }, speed); } }
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-slide-to'), 10)); play(); }); });
    var startX = null;
    slider.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { go(index + (dx < 0 ? 1 : -1)); play(); }
      startX = null;
    });
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) play();
  }
  $$('[data-slider]').forEach(initSlider);

  /* ---------- Horizontal scrollers ---------- */
  function initScroller(root) {
    var track = $('.scroller__track', root);
    var bar = $('[data-scroll-bar]', root);
    var prev = $('[data-scroll-prev]', root);
    var next = $('[data-scroll-next]', root);
    if (!track) return;
    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      root.classList.toggle('no-scroll', max <= 2);
      if (bar) {
        var ratio = track.clientWidth / track.scrollWidth;
        bar.style.width = Math.max(ratio * 100, 8) + '%';
        bar.style.left = (max > 0 ? (track.scrollLeft / max) * (100 - ratio * 100) : 0) + '%';
      }
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }
    function step(dir) {
      var item = $('.scroller__item', track);
      var w = item ? item.getBoundingClientRect().width + 16 : track.clientWidth;
      track.scrollBy({ left: dir * w * Math.max(1, Math.floor(track.clientWidth / w)), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }
  $$('[data-scroller]').forEach(initScroller);

  /* ---------- Dispatch countdown ---------- */
  $$('[data-countdown]').forEach(function (el) {
    var cutoff = parseInt(el.getAttribute('data-cutoff'), 10);
    var offset = parseFloat(el.getAttribute('data-tz')) || 0;
    var range = (el.getAttribute('data-days') || '1-6').split('-').map(Number);
    var h = $('[data-h]', el), m = $('[data-m]', el), s = $('[data-s]', el);
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var now = new Date(Date.now() + offset * 3600000); // store-local time expressed in UTC fields
      var target = new Date(now.getTime());
      target.setUTCHours(cutoff, 0, 0, 0);
      var guard = 0;
      while ((target <= now || target.getUTCDay() < range[0] || target.getUTCDay() > range[1]) && guard < 8) {
        target.setUTCDate(target.getUTCDate() + 1); target.setUTCHours(cutoff, 0, 0, 0); guard++;
      }
      var diff = Math.max(0, Math.floor((target - now) / 1000));
      h.textContent = pad(Math.floor(diff / 3600)); m.textContent = pad(Math.floor(diff % 3600 / 60)); s.textContent = pad(diff % 60);
    }
    tick(); setInterval(tick, 1000);
  });

  /* ---------- Cart: AJAX add + toast ---------- */
  var toast = $('[data-cart-toast]');
  var toastTimer;
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = count === 0 && el.classList.contains('header-cart__count'); });
  }
  function showToast(title) {
    if (!toast) return;
    $('[data-cart-toast-item]', toast).textContent = title || '';
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 6000);
  }
  if (toast) $('[data-cart-toast-close]', toast).addEventListener('click', function () { toast.hidden = true; });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    var action = form.getAttribute('action') || '';
    if (!/\/cart\/add\/?$/.test(action.split('?')[0])) return;
    if (e.submitter && e.submitter.classList.contains('shopify-payment-button__button')) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var stickyBtn = $('[data-sticky-add]');
    if (btn) btn.disabled = true;
    var body = new FormData(form);
    fetch(routes.cartAdd + '.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: body })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) { alert(res.json.description || res.json.message || 'Could not add to cart'); return; }
        showToast(res.json.product_title || res.json.title);
        return fetch(routes.cart + '.js').then(function (r) { return r.json(); }).then(function (cart) { updateCount(cart.item_count); });
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.disabled = false; if (stickyBtn) stickyBtn.disabled = false; });
  });

  /* ---------- Quantity buttons ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var min = parseInt(input.min || '0', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-qty'), 10));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  var cartForm = $('#CartForm');
  if (cartForm) {
    var cartTimer;
    cartForm.addEventListener('change', function (e) {
      if (!e.target.matches('[data-cart-qty]')) return;
      clearTimeout(cartTimer);
      cartTimer = setTimeout(function () {
        var input = document.createElement('input'); input.type = 'hidden'; input.name = 'update'; input.value = '1';
        cartForm.appendChild(input); cartForm.submit();
      }, 500);
    });
  }

  /* ---------- Collection / search filters (Section Rendering API) ---------- */
  function initFacets(section) {
    var id = section.getAttribute('data-section-id');
    var wrap = $('[data-facets-wrap]', section);

    function render(url, push) {
      var results = $('[data-results]', section);
      if (results) results.classList.add('is-loading');
      var openIds = $$('details.facet[open]', section).map(function (d) { return d.id; });
      var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + id;
      fetch(fetchUrl).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['[data-results]', '[data-results-count]', '[data-facets-wrap] .facets__form'].forEach(function (sel) {
          var fresh = doc.querySelector(sel), old = $(sel, section);
          if (fresh && old) old.innerHTML = fresh.innerHTML;
        });
        $$('details.facet', section).forEach(function (d) { if (openIds.indexOf(d.id) > -1) d.open = true; });
        if (push) history.pushState({ facets: true }, '', url);
        var freshResults = $('[data-results]', section); if (freshResults) freshResults.classList.remove('is-loading');
      }).catch(function () { window.location.href = url; });
    }
    function urlFromForm() {
      var form = $('[data-facets-form]', section);
      var params = new URLSearchParams();
      if (form) new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
      var sort = $('[data-sort]', section);
      if (sort && sort.value) params.set('sort_by', sort.value);
      return window.location.pathname + '?' + params.toString();
    }
    var debounce;
    section.addEventListener('change', function (e) {
      if (!e.target.closest('[data-facets-form]') && !e.target.matches('[data-sort]')) return;
      clearTimeout(debounce);
      debounce = setTimeout(function () { render(urlFromForm(), true); }, e.target.type === 'number' ? 600 : 50);
    });
    section.addEventListener('submit', function (e) {
      if (!e.target.matches('[data-facets-form]')) return;
      e.preventDefault(); render(urlFromForm(), true);
    });
    section.addEventListener('click', function (e) {
      var link = e.target.closest('[data-facet-link]');
      if (link) { e.preventDefault(); render(link.getAttribute('href'), true); return; }
      if (e.target.closest('[data-facets-open]') && wrap) { wrap.classList.add('is-open'); document.body.classList.add('is-locked'); }
      if (e.target.closest('[data-facets-close]') && wrap) { wrap.classList.remove('is-open'); document.body.classList.remove('is-locked'); }
      if (wrap && e.target === wrap) { wrap.classList.remove('is-open'); document.body.classList.remove('is-locked'); }
    });
    window.addEventListener('popstate', function () { render(window.location.href, false); });
  }
  $$('[data-results-section]').forEach(initFacets);

  /* ---------- Product page ---------- */
  function initProduct(root) {
    var variants = [];
    try { variants = JSON.parse($('[data-product-json]', root).textContent); } catch (err) {}
    var main = $('[data-gallery-main]', root);
    var thumbs = $$('[data-thumb]', root);
    var slides = main ? $$('.gallery__slide', main) : [];
    var indexEl = $('[data-gallery-index]', root);
    var current = 0;

    function setThumb(i) {
      current = i;
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      if (indexEl) indexEl.textContent = i + 1;
      var active = thumbs[i];
      if (active && active.parentNode.scrollHeight > active.parentNode.clientHeight) active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    function goTo(i) {
      if (!main || !slides.length) return;
      i = (i + slides.length) % slides.length;
      main.scrollTo({ left: main.clientWidth * i, behavior: 'smooth' }); setThumb(i);
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-thumb'), 10)); });
    });
    var prev = $('[data-gallery-prev]', root), next = $('[data-gallery-next]', root);
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    if (main) main.addEventListener('scroll', function () {
      var i = Math.round(main.scrollLeft / main.clientWidth);
      if (i !== current) setThumb(i);
    }, { passive: true });

    // Delivery estimate
    var stock = $('[data-stock]', root);
    if (stock) {
      var eta = $('[data-eta]', stock);
      var fmt = function (d) { return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short' }); };
      var addDays = function (n) { var d = new Date(); d.setDate(d.getDate() + n); return d; };
      eta.textContent = fmt(addDays(parseInt(stock.getAttribute('data-min-days'), 10))) + ' - ' + fmt(addDays(parseInt(stock.getAttribute('data-max-days'), 10)));
    }

    // Variant picker
    var picker = $('[data-variant-picker]', root);
    if (picker && variants.length) {
      picker.addEventListener('change', function () {
        var selected = $$('fieldset', picker).map(function (fs) {
          var c = $('input:checked', fs) || $('[data-option-select]', fs);
          return c ? c.value : null;
        });
        $$('[data-option-value]', picker).forEach(function (el, i) { el.textContent = selected[i]; });
        var variant = variants.filter(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); })[0];
        updateVariant(variant);
      });
    }
    function updateVariant(variant) {
      var idInput = $('[data-variant-id]', root);
      var add = $('[data-add-button]', root), label = $('[data-add-label]', root), sticky = $('[data-sticky-add]', root);
      if (!variant) {
        if (add) add.disabled = true; if (label) label.textContent = 'Unavailable'; if (sticky) sticky.disabled = true;
        return;
      }
      if (idInput) idInput.value = variant.id;
      var sale = variant.compare_at_price && variant.compare_at_price > variant.price;
      var cur = $('[data-price-current]', root), cmp = $('[data-price-compare]', root), price = $('[data-price]', root);
      if (cur) cur.textContent = formatMoney(variant.price);
      if (cmp) {
        cmp.hidden = !sale; cmp.textContent = sale ? formatMoney(variant.compare_at_price) : '';
        if (price) price.classList.toggle('price--sale', !!sale);
      }
      var saveText = $('[data-save-text]', root), saveBadge = $('[data-save-badge]', root);
      if (saveText) { saveText.hidden = !sale; saveText.textContent = sale ? 'Save ' + formatMoney(variant.compare_at_price - variant.price) : ''; }
      if (saveBadge) { saveBadge.hidden = !sale; if (sale) saveBadge.textContent = '-' + Math.floor((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%'; }
      var stickyPrice = $('[data-sticky-price]', root);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      $$('[data-emi]', root).forEach(function (box) {
        var amount = $('[data-emi-amount]', box);
        var months = parseInt(box.getAttribute('data-emi-months'), 10) || 1;
        if (amount) amount.textContent = formatMoney(Math.round(variant.price / months));
        var min = box.getAttribute('data-emi-min');
        if (min !== null) box.hidden = variant.price < parseInt(min, 10);
      });
      var sku = $('[data-sku]', root);
      if (sku) { sku.textContent = variant.sku || ''; sku.closest('[data-sku-row]').hidden = !variant.sku; }
      if (add) add.disabled = !variant.available;
      if (sticky) sticky.disabled = !variant.available;
      if (label) label.textContent = variant.available ? 'Add to cart' : 'Sold out';
      var pill = $('[data-stock-pill]', root);
      if (pill) {
        pill.classList.toggle('is-out', !variant.available);
        $('[data-stock-pill-text]', pill).textContent = variant.available ? pill.getAttribute('data-in') : pill.getAttribute('data-out');
      }
      if (variant.featured_media && main) {
        var slide = $('[data-media-id="' + variant.featured_media.id + '"]', main);
        if (slide) goTo(slides.indexOf(slide));
      }
      history.replaceState({}, '', root.getAttribute('data-url') + '?variant=' + variant.id);
    }

    // Sticky add to cart
    var stickyBar = $('[data-sticky-atc]', root);
    var addBtn = $('[data-add-button]', root);
    if (stickyBar && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        stickyBar.hidden = e.isIntersecting || e.boundingClientRect.top > 0 || e.boundingClientRect.height === 0;
      }).observe(addBtn);
    }
  }
  $$('[data-product]').forEach(initProduct);

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    if (el.querySelector('.scroller')) return;
    fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) {
        el.innerHTML = fresh.innerHTML;
        var sc = $('[data-scroller]', el); if (sc) initScroller(sc);
      }
    }).catch(function () {});
  });

  /* ---------- Product videos: play in view, tap for sound ---------- */
  var reelObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else { v.pause(); }
    });
  }, { threshold: 0.6 }) : null;
  function initReels(root) {
    $$('[data-reel] video', root).forEach(function (v) {
      v.muted = true;
      if (reelObserver && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) reelObserver.observe(v);
    });
  }
  initReels(document);
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-reel-sound]');
    if (!b) return;
    var v = b.parentElement.querySelector('video');
    $$('[data-reel] video').forEach(function (o) { if (o !== v) { o.muted = true; } });
    v.muted = !v.muted;
    if (!v.muted) v.play();
    b.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Turn sound off');
    b.innerHTML = v.muted ? SOUND_OFF : SOUND_ON;
  });
  var SOUND_OFF = '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H2v6h4l5 4z"/><path d="m22 9-6 6M16 9l6 6"/></svg>';
  var SOUND_ON = '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H2v6h4l5 4z"/><path d="M15.5 8.5a5 5 0 0 1 0 7M19 5a10 10 0 0 1 0 14"/></svg>';

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    $$('[data-finder]', t).forEach(initFinder);
    $$('[data-slider]', t).forEach(initSlider);
    initReels(t);
    $$('[data-scroller]', t).forEach(initScroller);
    $$('[data-product]', t).forEach(initProduct);
    $$('[data-results-section]', t).forEach(initFacets);
  });
})();
